import cn from "classnames";

export const EmptyStatePlaceholder: React.FC<{
    placeholderImage: JSX.Element;
    title: string;
    description?: string;
    className?: string;
}> = ({ placeholderImage, title, description, className }) => {
    return (
        <div className={cn("app-empty-state d-flex flex-column align-items-center m-auto justify-content-center", className)}>
            {placeholderImage}
            <div className="d-flex flex-column text-center">
                <h3 className="text-body fs-5 fw-semi-bold m-0 pb-1">{title}</h3>
                {!!description && <p className="m-0">{description}</p>}
            </div>
        </div>
    );
};
